var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"news-item",style:(_vm.mStyle),on:{"click":_vm.clickHandle}},[_c('p',{staticClass:"news-tip"},[_vm._v(_vm._s(_vm.dateFormat(_vm.item.publishTime,'YYYY-MM-DD')))]),_c('p',{staticClass:"news-tit"},[_vm._v(" "+_vm._s(_vm.item.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }